export default __webpack_public_path__ + "static/media/logo-dark.b8dfb0d0.svg";